import * as StoreTypes from "./DataTypes/storeTypes";
import * as StripeTypes from "./DataTypes/stripeTypes";

export function getDefaultState(settings: StoreTypes.IInitialSettings): StoreTypes.IStore {
    return {
        initialSettings: {
            ...settings,
        },
        common: {
            status: settings.compositionParams.status,
            composition: settings.compositionParams.composition,
        },
        stripe: {
            stripeState: StripeTypes.StripeState.None,
            cardInfo: null,
            isCreditCardEdit: false,
        },
        stripeForm: {},
    };
}

export function getGridDefaultState(settings: StoreTypes.IGridInitialSettings): StoreTypes.IStoreCustomFormGrid {
    return {
        initialSettings: {
            ...settings,
        },
    };
}
